import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import url from 'url';
import get from 'lodash/get';

import Booking from 'models/booking';
import Brand from 'models/brand';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  useAnchorElement: PropTypes.bool,
};

const defaultProps = {
  useAnchorElement: false,
};

const ParkingPass = ({ booking, brand, useAnchorElement }) => {
  const parsedURL = url.parse(get(booking, 'parkingPassURL', ''));
  const buttonClasses = cx({
    'btn': true,
    'btn-bp': brand.isBestParking,
    'btn-block': true,
    'btn-primary': true,
    'btn-bottom-attached': true,
    'btn-md': true,
    'text-weight-book': true,
    'soft-hidden': booking.isMonthly,
  });

  if (booking.isMonthly) {
    return <div className={buttonClasses} />;
  }

  if (booking.onDemand) {
    return (
      <a
        href={booking.getDeepLink(brand).url}
        className={buttonClasses}
      >
        VIEW IN APP
      </a>
    );
  }

  // This is a hack for rendering this button in components/bookings/
  // past/past-booking-modal.jsx. It renders outside of a Router context,
  // which the Link component does not allow.
  if (useAnchorElement) {
    return (
      <a
        href={get(parsedURL, 'path', '')}
        className={buttonClasses}
      >
        Parking Pass
      </a>
    );
  }

  return (
    <Link
      to={get(parsedURL, 'path', {})}
      className={buttonClasses}
    >
      Parking Pass
    </Link>
  );
};

ParkingPass.propTypes = propTypes;
ParkingPass.defaultProps = defaultProps;

export default ParkingPass;
